import { render } from "./partner.vue?vue&type=template&id=335c20b6&scoped=true"
import script from "./partner.vue?vue&type=script&lang=js"
export * from "./partner.vue?vue&type=script&lang=js"

import "./partner.vue?vue&type=style&index=0&id=335c20b6&lang=less&scoped=true"

import exportComponent from "E:\\pc\\hifan-pc\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-335c20b6"]])

export default __exports__